import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050505] py-12 border-t border-gray-900" data-id="element-96">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-97">
        <div className="flex items-center" data-id="element-98">
          <img src="https://cdn.magicpatterns.com/uploads/gmjbqi7Rif9BiiKcd8ezw3/logo_fondo_negro.jpg" alt="Kiron Performance Logo" className="h-10 object-contain mix-blend-screen opacity-80 hover:opacity-100 transition-opacity" data-id="element-99" />
        </div>

        <div className="text-gray-500 text-sm font-light" data-id="element-100">
          &copy; {new Date().getFullYear()} Kiron Performance. Todos los
          derechos reservados.
        </div>

        <div className="flex space-x-4" data-id="element-101">
          <a href="https://www.instagram.com/kironperformance/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-kiron-teal transition-colors" data-id="element-102">
            <Instagram size={24} data-id="element-103" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61579745503085" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-kiron-teal transition-colors" data-id="element-104">
            <Facebook size={24} data-id="element-105" />
          </a>
        </div>
      </div>
    </footer>;
}